import React from 'react'
import { useState } from 'react';
import './ProfileProgress.css'

const ProfileProgress = (props) => {
    const [style, setStyle] =useState({});
	
    setTimeout(() => {
        const newStyle = {
            opacity: 1,
            width: `${props.done}%`
        }
		
        setStyle(newStyle);
    }, 200);
	
    return (
        <div className={props.progress}>
            <div className={props.progressDone} style={style}>
                <p style={{display:props.disp}} className="percentFont">{props.done}%</p>
            </div>
        </div>
    )
}


export default ProfileProgress